import React from 'react';
import IntroduceContainer from 'containers/IntroduceContainer/IntroduceContainer';

export default function IntroducePage() {
    return (
        <IntroduceContainer />
    )
}
 